<template>
  <div>
    <table
      class="mt-3 mb-1 table table-striped table-bordered table-sm"
      style="width:100%;font-size:.9rem;"
    >
      <thead>
        <tr>
          <th v-if="isOpen"  class="align-middle text-center text-success cursor-pointer"
            rowspan="2" title="Aggiungi immobile" @click="apriForm()" >
            <font-awesome-icon icon="plus" class="cursor-pointer text-success" />
          </th>
          <th
            class="align-middle text-center pl-3 text-uppercase"
            rowspan="2"
          >
            Tipologia<br>immobile (**)
          </th>
          <th
            class="align-middle text-center"
            rowspan="2"
          >
            UBICAZIONE<br>(Località e indirizzo)
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            % Titolarità
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Superficie<br>netta
          </th>
          <th
            class="align-middle text-center text-uppercase"
            colspan="4"
          >
            Dati identificativi catastali
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Rendita
          </th>
        </tr>
        <tr>
          <th class="align-middle text-center">
            Foglio
          </th>
          <th class="align-middle text-center">
            Numero
          </th>
          <th class="align-middle text-center">
            Subalterno
          </th>
          <th class="align-middle text-center">
            Categoria
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(i,idx) in rows" :key="i.idx">
          <td v-if="isOpen"  class="align-middle text-center text-success"
            title="Modifica immobile" @click="apriForm(idx)"
          >
            <font-awesome-icon icon="pen" class="cursor-pointer text-success"/>
          </td>
          <td class="align-middle text-left">
            {{ i.codiceTipoImmobile }}
          </td>
          <td class="align-middle text-left">
            {{ i.descrizioneComune }} ({{ i.provincia }}) - {{ i.indirizzo }}
          </td>
          <td class="align-middle text-center">
            {{ i.percTitolarita }} %
          </td>
          <td class="align-middle text-center">
            {{ i.superficieNetta }} mq
          </td>
          <td class="align-middle text-center">
            {{ i.foglio }}
          </td>
          <td class="align-middle text-center">
            {{ i.numero }}
          </td>
          <td class="align-middle text-center">
            {{ i.subalterno }}
          </td>
          <td class="align-middle text-center">
            {{ i.categoria }}
          </td>
          <td class="align-middle text-center">
            {{ numeral(i.rendita || 0).format() }} €
          </td>
        </tr>
        <tr v-if="!rows || !rows.length">
          <td :colspan="!isOpen ? '9' : '10'" class="text-center font-italic">
            Nessun immobile dichiarato
          </td>
        </tr>
      </tbody>
    </table>

    <div class="small text-left">
      (**) <b>F</b>=fabbricati; <b>AF</b>=aree fabbricabili; <b>T</b>=terreni agricoli
    </div>

    <immobile-modal ref="modal" />

  </div>
</template>

<script>
import numeral from 'numeral'
import ImmobileModal from '@/components/ImmobileModal'

export default {
  name: 'ImmobiliTable',
  components: {
    ImmobileModal
  },
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    numeral () {
      return numeral
    },
    isOpen () {
      // return this.item.stato === 'A'
      // console.log('(Redditi) Se dichiarazione P o B: ', this.item.stato, this.item.stato === 'B' || this.item.stato === 'P')
      return this.item.stato === 'B'
      // return this.item.stato === 'B' || this.item.stato === 'P'
    },
    rows () {
      return this.item.immobili
    }
  },
  methods: {
    apriForm (idx) {
      // GM: prova per tabella vuota
      // if (!this.item.immobili) this.item.immobili = []
      // fine della prova
      this.$refs.modal.open({ item: this.item, idx })
    }
  }
}
</script>
